var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { runtime } from '../Runtime';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { bound } from '../../../utils/decorators/basic';
export class AsyncPackage {
    parent;
    fetchPackageFunction;
    packageFetch;
    constructor({ parent, fetchPackage }) {
        makeObservable(this);
        this.parent = parent;
        if (runtime.isBrowserRuntime) {
            this.fetchPackageFunction = fetchPackage;
        }
    }
    get packageName() {
        const [key, value] = Array.from(Object.entries(this.parent).find(([key, value]) => value === this));
        return key;
    }
    get packages() {
        return this.parent;
    }
    get streamedPackage() {
        if (this.isAvailable) {
            return this.availablePackage;
        }
        setTimeout(this.fetchPackage, 0);
        return this.availablePackage;
    }
    async fetchPackage() {
        if (this.isAvailable) {
            return this.availablePackage;
        }
        if (this.packageFetch)
            return await this.packageFetch;
        this.packageFetch = this.fetchPackageUniqueLoad();
        return await this.packageFetch;
    }
    async fetchPackageUniqueLoad() {
        const PackageClass = await this.fetchPackageFunction();
        const packageInstance = new PackageClass[`Package${this.packageName}`](this);
        await runtime.runtimeScheduler.addToNextStateChange(() => {
            this.packages.setPackage(this.packageName, packageInstance);
        });
        return packageInstance;
    }
    get isAvailable() {
        return runtime.isServerRuntime || this.packages.packageInstances.has(this.packageName);
    }
    get availablePackage() {
        if (runtime.isServerRuntime) {
            return runtime.solidServerRuntime.serverPackages[this.packageName];
        }
        return this.packages.packageInstances.get(this.packageName);
    }
}
__decorate([
    memoize
], AsyncPackage.prototype, "packageName", null);
__decorate([
    computed
], AsyncPackage.prototype, "streamedPackage", null);
__decorate([
    bound
], AsyncPackage.prototype, "fetchPackage", null);
__decorate([
    bound
], AsyncPackage.prototype, "fetchPackageUniqueLoad", null);
__decorate([
    computed
], AsyncPackage.prototype, "availablePackage", null);
